<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent scrollable max-width="290px">
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ title }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-list>
                        <template v-for="(item, index) in items">
                            <v-list-tile
                                :key="item.title"
                                ripple
                                @click="select(index)"
                            >
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                    </v-list>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="setAnswer(false)">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        name: "ListSelectDialog",

        data () {
            return {
                dialog: false,
                items: [],
                selected: [],
                title: "",
                answer: null
            }
        },

        watch: {
            dialog (val) {
                if (val) { this.answer = null; }
            }
        },

        methods: {
            /**
             * Установка ответа и закрытие диалога
             */
            setAnswer (val) {
                this.answer = val;
                this.dialog = false;
            },

            /**
             * Выбло элемента
             */
            select (index) {
                this.selected = this.items[index];
                this.setAnswer(true);
            }
        }
    }
</script>
